<div *ngIf="errorMessage" class="input-error">
  <ng-container *ngFor="let error of errorMessage">
    <div class="error-message inline-block">{{error}}</div>
  </ng-container>
</div>